export class RetainCampaignBuilder {
    constructor() {
        this.campaign = {};
    }

    setId(id){
        this.campaign.id = id;
        return this;
    }

    setName(name){
        this.campaign.name = name;
        return this;
    }

    setConversations(conversations){
        this.campaign.conversations = conversations;
        return this;
    }

    setRevenue(revenue) {
        this.campaign.revenue = revenue;
        return this;
    }


    setRevenuePerRecipient(revenuePerRecipient) {
        this.campaign.revenuePerRecipient = revenuePerRecipient;
        return this;
    }

    setAverageOrderValue(averageOrderValue) {
        this.campaign.averageOrderValue = averageOrderValue
        return this
    }

    setConversionRate(conversionRate) {
        this.campaign.conversionRate = conversionRate
        return this
    }

    setOrders(orders) {
        this.campaign.orders = orders
        return this
    }

    setActions(actions){
        this.campaign.actions = actions;
        return this;
    }

    setParam(param){
        this.campaign.param = param;
        return this;
    }

    build(){
        return this.campaign;
    }
}
